import { getTraceId } from 'utils/traceIdHelper'
import { createRequestInterceptor } from '../createInterceptor'

export const traceIdInterceptor = createRequestInterceptor(() => (config) => {
  const traceId = getTraceId()
  if (config?.url?.includes('media.evreka.co')) {
    return config
  }
  config.headers['Evreka-Trace-Id'] = traceId
  return config
})
